import { enableProdMode } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { createApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { WidgetComponent } from './app/widget/widget.component';
import { environment } from './environments/environment';
// import { init } from '@sentry/angular';
// import { SentryConfig } from './sentry.config';

if (environment?.production) {
  enableProdMode();
  // init(SentryConfig);
}

(async () => {
  const app = await createApplication(appConfig);

  const bookingElement = createCustomElement(WidgetComponent, {
    injector: app.injector,
  });
  customElements.define(environment.bookingElementName, bookingElement);
})();